// CONTEXT
import { ShipmentsProvider } from "../../contexts/shipments/shipments.context";

// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import ShippingPage from "./page.shipping.page";

const ShippingLayout = () => {
  return (
    <LoggedIn>
      <ShipmentsProvider>
        <ShippingPage />
      </ShipmentsProvider>
    </LoggedIn>
  );
};

export default ShippingLayout;
